import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/Layout.vue";
import ChatLayout from "../views/ChatLayout_test.vue";
import ListchatLayout from "../views/ListchatLayout.vue";
import HomepageLayout from "../views/HomepageLayout_test.vue";
import AddFriend from "../views/AddFriend.vue";
import CreateGroup from "../views/CreateGroup.vue";
import ProfileUser from "../views/ProfileUser.vue";
import ProfileFriend from "../views/ProfileFriend.vue";
import ProfileGroup from "../views/ProfileGroup.vue";
import AuthenLogin from "../views/AuthenLogin.vue";
import EditPhone from "../views/EditPhone.vue";
import ChatRoomMenu from "../views/ChatRoomMenu.vue";
import policy from "../views/other/policy.vue";
import ConsentBot from "../views/consent/ConsentBot.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Layout,
    children: [
      { path: '/homepage', name: 'homepage', component: HomepageLayout },
      { path: '/listchat', name: 'lischat', component: ListchatLayout },
      { path: '/chat/:tokenroom', name: 'chat', component: ChatLayout },
      { path: '/chat/menu/:tokenroom/:type', name: 'chatroommenu', component: ChatRoomMenu }
    ]
  },
  { path: '/addfriend', name: 'addfriend', component: AddFriend },
  { path: '/creategroup', name: 'creategroup', component: CreateGroup },
  { path: '/profile', name: 'profileuser', component: ProfileUser },
  { path: '/profile/editphone', name: 'editphone', component: EditPhone },
  { path: '/profile/friend/:tokenuser', name: 'profilefriend', component: ProfileFriend },
  { path: '/profile/group/:groupid', name: 'profilegroup', component: ProfileGroup },
  { path: '/authen', name: 'authen', component: AuthenLogin },
  { path: '/policy', name: 'policy', component: policy },
  { path: '/check-consent/:tokenroom', component: ConsentBot },
  { path: '*', redirect: '/' }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH,
  routes,
});

export default router;
